import { render, staticRenderFns } from "./v-doc-type-chip.vue?vue&type=template&id=48d7d080"
import script from "./v-doc-type-chip.vue?vue&type=script&lang=js"
export * from "./v-doc-type-chip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports